import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { BitfFile } from '@bitf/core/models';

@Component({
  selector: 'hero-preview-upload-file-detail',
  templateUrl: './preview-upload-file-detail.component.html',
  styleUrls: ['./preview-upload-file-detail.component.scss'],
})
export class PreviewUploadFileDetailComponent implements OnInit {
  @Input() files: BitfFile[];
  @Output() removeFile = new EventEmitter<number>();

  constructor() {}

  ngOnInit(): void {
    console.log(this.files);
  }

  trackByFn(index) {
    return index;
  }

  onRemoveFile(index: number) {
    if (this.removeFile) {
      this.removeFile.emit(index);
    }
  }
}
